import { mapGetters, mapState } from 'vuex';

const dateFormat = 'YYYY-MM-DD';

export default {
  computed: {
    ...mapState(['filters']),
    ...mapGetters({ rangesTimeZone: 'timeZone' }),
    dateRanges() {
      return this.buildDateRanges(this.now());
    },
    currentFixedRange() {
      return this.matchFixedRange(this.dateRanges);
    },
  },
  methods: {
    now(timeZone = this.rangesTimeZone) {
      return moment().tz(timeZone);
    },
    buildDateRanges(now) {
      // Server to JS
      const startWeekOn = toMomentIsoWeekday(this.startWeekOn);

      // - Today - Tomorrow
      // - Yesterday - Today
      // - Monday - Monday next week
      // - Monday last week - Monday this week
      // - 1st of Month - 1st of next Month
      // - 1st of last Month - 1st of Month

      return [
        {
          // Today
          id: 'today',
          label: 'Today',
          from: now.clone().startOf('day'),
          to: now.clone().endOf('day'),
        },
        {
          // Yesterday
          id: 'yesterday',
          label: 'Yesterday',
          from: now.clone().startOf('day').subtract(1, 'day'),
          to: now.clone().endOf('day').subtract(1, 'day'),
        },
        {
          // This week
          id: 'this-week',
          label: 'This week',
          from: now.clone().startOfIsoWeek(startWeekOn),
          to: now.clone().endOf('day'),
        },
        {
          // Last week
          id: 'last-week',
          label: 'Last week',
          from: now.clone().subtract(1, 'weeks').startOfIsoWeek(startWeekOn),
          to: now.clone().subtract(1, 'weeks').endOfIsoWeek(startWeekOn),
        },
        {
          // This month
          id: 'this-month',
          label: 'This month',
          from: now.clone().startOf('month'),
          to: now.clone().startOf('day'),
        },
        {
          // Last month
          id: 'last-month',
          label: 'Last month',
          from: now.clone().subtract(1, 'month').startOf('month'),
          to: now.clone().startOf('month').subtract(1, 'day'),
        },
      ];
    },
    matchFixedRange(ranges) {
      const dateRange = {
        from: moment(this.filters.date.from),
        to: moment(this.filters.date.to),
      };

      return (
        ranges.find((range) => {
          return (
            range.from.format(dateFormat) === dateRange.from.format(dateFormat) &&
            range.to.format(dateFormat) === dateRange.to.format(dateFormat)
          );
        }) || null
      );
    },
  },
};
